import { useCallback, useRef } from "react"

interface PendingMutation {
  id: string
  type: "create" | "delete" | "reaction"
  timestamp: number
  data?: unknown
}

export function useCommentSync() {
  const pendingMutations = useRef<Map<string, PendingMutation>>(new Map())
  const lastUpdateTimestamp = useRef<Map<string, number>>(new Map())

  const isPendingMutation = useCallback((mutationId: string): boolean => {
    return pendingMutations.current.has(mutationId)
  }, [])

  const shouldProcessUpdate = useCallback(
    (entityId: string, updateTimestamp?: number): boolean => {
      // If we have a pending mutation for this entity, skip the update
      if (isPendingMutation(entityId)) {
        return false
      }

      // If we have a timestamp, check if this update is newer than the last one we processed
      if (updateTimestamp) {
        const lastTimestamp = lastUpdateTimestamp.current.get(entityId) || 0
        if (updateTimestamp <= lastTimestamp) {
          return false
        }
        lastUpdateTimestamp.current.set(entityId, updateTimestamp)
      }

      return true
    },
    [isPendingMutation]
  )

  return {
    shouldProcessUpdate,
  }
}
